import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import TruncateMarkup from 'react-truncate-markup';
import { propBool, propStr } from '../../../../helpers/custom-prop-types';
import BlurText from '../../Common/BlurText';
import SplitText from '../../Common/SplitText';
import AboutAccordion from './AboutAccordion';
class AboutTextAccordion extends Component {
    constructor(props) {
        super(props);
        this.onChange = (e) => {
            this.setState({
                isOpen: e.currentTarget.checked,
            });
        };
        this.onTruncate = (isTruncate) => {
            this.setState({ isTruncate });
        };
        this.renderFunc = (row) => (_jsx(BlurText, Object.assign({ component: 'span', isBlur: true }, { children: row })));
        this.state = {
            isOpen: false,
            isTruncate: false,
        };
    }
    render() {
        const { boxClassName, buttonClassName, isBlur, name, text, textClassName, title, } = this.props;
        const { isOpen, isTruncate } = this.state;
        return (_jsx("section", { children: _jsxs("div", Object.assign({ className: `about-box ${boxClassName}` }, { children: [_jsxs("h2", Object.assign({ className: `about-title accordion-${name}-title has-description` }, { children: [title, _jsx("small", { children: "\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u304B\u3089\u306E\u30E1\u30C3\u30BB\u30FC\u30B8" })] })), _jsx("div", Object.assign({ className: `about-text ${textClassName}` }, { children: isBlur ? (_jsx(SplitText, { renderFunc: this.renderFunc, text: text })) : (_jsxs(_Fragment, { children: [!isOpen && (_jsx(TruncateMarkup, Object.assign({ lines: 5, onTruncate: this.onTruncate }, { children: _jsx("pre", Object.assign({ className: 'is-truncate' }, { children: text })) }))), (isOpen || isTruncate) && (_jsx(AboutAccordion, Object.assign({ buttonClassName: buttonClassName, keyId: `accordion-${name}`, onChange: this.onChange, openText: 'View More' }, { children: _jsx("pre", Object.assign({ className: 'is-truncate overflow-y-hidden' }, { children: text })) })))] })) }))] })) }));
    }
}
AboutTextAccordion.propTypes = {
    boxClassName: propStr().isRequired,
    buttonClassName: propStr(),
    isBlur: propBool().isRequired,
    name: propStr().isRequired,
    text: propStr(),
    textClassName: propStr().isRequired,
    title: propStr().isRequired,
};
AboutTextAccordion.defaultProps = {
    buttonClassName: '',
    text: '',
};
export default AboutTextAccordion;
